// ROUTES PATHS

const paths = {
  // Public
  Root: "/",
  Register: "/register",
  ForgotPassword: "/forgot-password",
  ResetPassword: "/reset-password",
  FAQs: "/faqs",

  // Protected (inside Auth layout)
  CreateDocumentWithAi: "/create-documents",
  Chat: "/chat",
  LegalDocuments: "/legal-documents",
  Arbitrators: "/arbitrators",

  DigitalDashboard: "/digital-dashboard",
  DigitalSignaturePrepare: "/digital-signature-prepare",
  digitalDocumentEdit: "/digital-document-edit",
  DigitalDocumentDetails: "/digital-document-details",

  CreateTemplate: "/create-template",
  EditTemplate: "/edit-template",

  Profile: "/profile",
  EditProfile: "/edit-profile",
  ApiKeyManagement: "/api-key-management",
  ApiKeyDashboard: "/api-key-management/dashboard",
  ApiKeyKeys: "/api-key-management/api-keys",
  ApiKeyFaqs: "/api-key-management/faqs",
  ApiDocs: "/api-key-management/docs",
  ApiKeyContractSetting: "/api-key-management/contract-setting",

  // api-key token authentication
  DigitalDocumentEditToken: "/digital-document-edit/token",

  // Admin paths
  AdminRoot: "/admin",
  AdminContactUs: "/admin/contactus",
  AdminBlogUpload: "/admin/uploadblog",
  AdminBlogList: "/admin/bloglists",
  pricing: "/admin/pricing",
  features: "/admin/features",
  events: "/admin/events",
  partners: "/admin/partners",
  uploadTemplates: "/admin/upload-templates",
  lbtAccounts: "/admin/lbt-accounts",
  manageAccounts: "/admin/manage-accounts",
  AdminApiManagement: "/admin/api-management",
  AdminContractSettings: "/admin/contract-settings",
  AdminEmailTemplates: "/admin/email-templates",
  AdminPublicDocuments: "/admin/public-documents",

  // Public pages (no auth required)
  ApiDocsPublic: "/api-docs",
};

export default paths;
